import {CustomButton} from "@/utils/buttons/custom-button";

const ASSISTANT_BROWSE_CONTEXTS: {[browseId: number]: string} = {
	1: "clients",
	2: "suppliers",
	3: "prospects",
	4: "products",
	5: "stock",
	6: "sales",
	8: "bank"
};

function createAssistantButton(context: string): CustomButton {
	let button = new CustomButton();
	button.Name = "Assistent";
	button.Title = "Assistent";
	button.Url = `https://assistent.winfakt.tools/?context=${context}`;
	button.Icon = "comments";
	button.AdminOnly = true;
	button.IntegrateInBrowse = true;
	button.IframePosition = "right";
	button.IframeWidthMode = 2;
	button.IframeFixedWidth = 544;
	return button;
}

export function getFixedCustomButtonsForBrowse(browseId: number): CustomButton[] {
	let context = ASSISTANT_BROWSE_CONTEXTS[browseId];
	if (!context) {
		return [];
	}
	return [createAssistantButton(context)];
}
